import React from 'react';

import { toastError, toastSuccess } from '@components/Toast';

import { fetchFabricCategory } from '@services/commonService';

import ApiClient from '@lib/apiClient';

import { checkAnyUserType, getUserInfo, printApiError, removeEmptyFilterParams } from '@utils/Util';

import { MATERIALS_TYPE } from '@/constants/constant';

export const getTransactionType = (materialData) => {
	return !materialData?.stockQuantity || materialData?.stockQuantity < 1
		? TRANSACTION_TYPE.RECEIVE
		: TRANSACTION_TYPE.ISSUE;
};
export const MATERIALS = 'Materials';
export const FAVOURITES = 'Favourites';
export const docType = {
	MATERIAL_FEATURE_IMAGE: 'MATERIAL_FEATURE_IMAGE',
	MATERIAL_FRONT_IMAGE: 'MATERIAL_FRONT_IMAGE',
	MATERIAL_DETAILS_IMAGE: 'MATERIAL_DETAILS_IMAGE'
};
/**
 * status (
 *      ------------- inventory issue log -------------------------
 *      BOOKED( 33 ) => booked for designer,
 *      APPROVED(4) => booked to issue APPROVED,
 *      CANCELLED(21) => booked canceled and 20 days after,
 *      RETURNED( 34 ) => booked return to received inventory,
 *      REJECTED( 7 ) => deleted,
 *      ------------ inventory received log -----------------------
 *      ACTIVE(15) => when receiveLog add and front-end right button click then active,
 *      DISABLED(16) => when front-end wrong button click then disabled
 *      )
 */
export const STATUS = {
	ACTIVE: 'ACTIVE',
	BOOKED: 'BOOKED',
	APPROVED: 'APPROVED',
	CANCELLED: 'CANCELLED',
	RETURNED: 'RETURNED',
	REJECTED: 'REJECTED',
	EXPIRED: 'EXPIRED',
	DISABLED: 'DISABLED'
};
export const VIEW_TYPE_OBJ = {
	COLLECTION_LIST: {
		type: 'COLLECTION_LIST',
		name: 'collectionDetailsViewType'
	},
	COLLECTION_DETAILS: {
		type: 'COLLECTION_DETAILS',
		name: 'collectionDetailsViewPage'
	},
	FAVOURITE_LIST: {
		type: 'FAVOURITE_LIST',
		name: 'favouritePageViewType'
	},
	MATERIAL_LIST: {
		type: 'MATERIAL_LIST',
		name: 'materialListViewType'
	},
	SAMPLE_DETAILS: {
		type: 'SAMPLE_DETAILS',
		name: 'sampleDetailsViewType'
	},
	POM_LIST: {
		type: 'POM_LIST',
		name: 'POM_LIST_VIEW_TYPE'
	},
	POM_TAG_LIST: {
		type: 'POM_TAG_LIST',
		name: 'POM_TAG_LIST_VIEW_TYPE'
	},
	BLOCK_LIBRARY_LIST: {
		type: 'BLOCK_LIBRARY_LIST',
		name: 'BLOCK_LIBRARY_LIST_TYPE'
	},
	SCAN_VIEW_TYPE: {
		type: 'SCAN_VIEW_TYPE',
		name: 'SCAN_VIEW_TYPE'
	}
};
export const FABRIC_TYPE = {
	WOVEN: {
		order: 0,
		enum: 'WOVEN',
		name: 'Woven',
		code: 'W',
		weightUnit: 'GSM',
		unit: 'Yard',
		shortUnit: 'YRD'
	},
	KNIT: {
		order: 1,
		enum: 'KNIT',
		name: 'Knit (Jersey)',
		code: 'K',
		weightUnit: 'GSM',
		unit: 'Kg',
		shortUnit: 'KG'
	},
	SWEATER: {
		order: 2,
		enum: 'SWEATER',
		name: 'Sweater (Flat Knit)',
		code: 'S',
		weightUnit: 'Gauge',
		unit: 'LBS',
		shortUnit: 'LBS'
	},
	DENIM: {
		order: 3,
		enum: 'DENIM',
		name: 'Denim',
		code: 'D',
		weightUnit: 'OZ',
		unit: 'Yard',
		shortUnit: 'YRD'
	},
	FUNCTIONAL: {
		order: 4,
		enum: 'FUNCTIONAL',
		name: 'Functional',
		code: 'F',
		weightUnit: 'GSM',
		unit: 'Kg',
		shortUnit: 'KG'
	},
	NON_WOVEN: {
		order: 5,
		enum: 'NON_WOVEN',
		name: 'Non-Woven',
		code: 'N',
		weightUnit: 'GSM',
		unit: 'Yard',
		shortUnit: 'YRD'
	}
};
export const FABRIC_TYPE_LIST = [
	FABRIC_TYPE.WOVEN,
	FABRIC_TYPE.KNIT,
	FABRIC_TYPE.SWEATER,
	FABRIC_TYPE.DENIM,
	FABRIC_TYPE.FUNCTIONAL,
	FABRIC_TYPE.NON_WOVEN
];
export const getFabricTypeName = (fabricType) => {
	return FABRIC_TYPE_LIST.find((items) => items.enum === fabricType);
};
export const getFixedFabric = (item) => {
	return {
		id: item.enum,
		name: `${item.name}`,
		fabricType: 'FIXED'
	};
};

export const isFabric = (materialType) => {
	return [
		'LIBRARY_FABRIC',
		'MAIN_FABRIC',
		'EXTRA_FABRIC',
		'LIBRARY FABRIC',
		'MAIN FABRIC',
		'EXTRA FABRIC'
	].includes(materialType);
};

export const getConsumptionUnit = (materialData) => {
	let value = materialData?.fabricDetailsTableResponse?.fabricType;
	if (materialData?.quantityUnit) return 'PCS';
	else if (value) return FABRIC_TYPE_LIST.find((item) => item.name === value)?.unit;
};
export const getConsumptionShortUnit = (materialData) => {
	let value = materialData?.fabricDetailsTableResponse?.fabricType;
	if (materialData?.quantityUnit) return 'PCS';
	else if (value) return FABRIC_TYPE_LIST.find((item) => item.name === value)?.shortUnit;
};
export const getConsumptionByKeyNameWise = (type, keyName) => {
	if (type) return FABRIC_TYPE_LIST.find((item) => item.name === type)?.[keyName];
};
export const getConsumptionUnitForTrimsAccessories = (materialData) => {
	let value = materialData?.trimsAndBrandingTableResponse?.subCategoryType?.consumptionUnit;
	if (value) return value;
	else return '';
};

export const userNameSet = (user) => {
	if (user === undefined || user === null) return '';
	return user?.nickName === undefined ? user?.name : user?.nickName;
};

export const whichUserMaterialBookedCheck = () => {
	return (
		getUserInfo()?.country?.name !== 'Turkey' &&
		checkAnyUserType(['FASHION_DESIGNER', 'GRAPHICS_DESIGNER', 'PRODUCT_DEVELOPMENT'])
	);
};

export const whichUserInventoryCheck = () => {
	return checkAnyUserType(['ADMIN', 'INVENTORY_MANAGEMENT']);
};

export const whichUserMaterialEditAndDuplicateAndDeleteCheck = () => {
	return checkAnyUserType(['ADMIN', 'INVENTORY_MANAGEMENT', 'MATERIAL_MANAGEMENT']);
};
export const whichUserUploadImageCheckForFabric = () => {
	return checkAnyUserType(['ADMIN', 'INVENTORY_MANAGEMENT']);
};

export const inventoryEditPermission = (item) => {
	if (item?.isExpired || !whichUserInventoryCheck()) return false;
	else return true;
};

export const setCardNameInfo = (item, activeStep) => {
	if (activeStep === MATERIALS_TYPE.FABRIC) {
		return fabricCardName(item);
	} else if (activeStep === MATERIALS_TYPE.TRIMS || activeStep === MATERIALS_TYPE.ACCESSORIES) {
		return trimsAndAccessoriesCardName(item);
	}
};
export const fabricCardName = (item) => {
	let compostionParName = item?.fabricDetailsTableResponse?.compositionPartList
		?.map((compositionPart) => {
			return compositionPart?.percentage + '% ' + compositionPart?.fiberName?.toProperCase();
		})
		.join(' ');
	return (
		item?.fabricDetailsTableResponse?.construction +
		' • ' +
		compostionParName +
		(item?.fabricDetailsTableResponse?.gsm
			? ', ' +
				item?.fabricDetailsTableResponse?.gsm +
				' ' +
				item?.fabricDetailsTableResponse?.weightUnit
			: '')
	);
};
export const trimsAndAccessoriesCardName = (item) => {
	let trimsInfo = item?.trimsAndBrandingTableResponse;
	let subCategoryType = trimsInfo?.subCategoryType;
	if (subCategoryType !== undefined)
		return (
			subCategoryType?.name +
			' • ' +
			(trimsInfo?.sustainability && trimsInfo?.sustainability?.text !== 'Regular'
				? ' ' + trimsInfo?.sustainability?.text
				: '') +
			(trimsInfo?.sustainability &&
			trimsInfo?.sustainability?.text !== 'Regular' &&
			trimsInfo?.materialQuality
				? ', '
				: '') +
			(trimsInfo?.materialQuality ? trimsInfo?.materialQuality?.text : '') +
			(trimsInfo?.technique ? ', ' + trimsInfo?.technique?.text : '') +
			(trimsInfo?.widthFromEdges
				? ', W(Edges): ' + trimsInfo?.widthFromEdges + ' ' + subCategoryType?.widthFromEdges
				: '') +
			(trimsInfo?.widthInside
				? ', W(Inside): ' + trimsInfo?.widthInside + ' ' + subCategoryType?.widthInside
				: '') +
			(trimsInfo?.diameter ? ', D: ' + trimsInfo?.diameter + ' ' + subCategoryType?.diameter : '') +
			(trimsInfo?.length ? ', L: ' + trimsInfo?.length + ' ' + subCategoryType?.length : '') +
			(trimsInfo?.height ? ', H: ' + trimsInfo?.height + ' ' + subCategoryType?.height : '') +
			(trimsInfo?.zipperNumber
				? ', Z: ' + trimsInfo?.zipperNumber + ' ' + subCategoryType?.zipperNumber
				: '') +
			(trimsInfo?.numberOfHole
				? ', Hole: ' + trimsInfo?.numberOfHole + ' ' + subCategoryType?.numberOfHole
				: '') +
			(trimsInfo?.details ? ', ' + trimsInfo?.details : '')
		);
	else return '';
};
export const TRANSACTION_TYPE = {
	ISSUE: { value: 'Issue', enum: 'ISSUE' },
	RECEIVE: { value: 'Receive', enum: 'RECEIVE' },
	WASTAGE: { value: 'Wastage', enum: 'WASTAGE' }
};

export const getMaterialType = (name) => {
	switch (name) {
		case MATERIALS_TYPE.FABRIC:
			return MATERIALS_TYPE.MAIN_FABRIC;
		case MATERIALS_TYPE.TRIMS:
		case MATERIAL_TITLE_NAME.TRIMS:
			return MATERIALS_TYPE.TRIMS;
		case MATERIALS_TYPE.ACCESSORIES:
		case MATERIAL_TITLE_NAME.BRANDING:
			return MATERIALS_TYPE.BRANDING;
		default:
			return name;
	}
};

export const fetchSupplierListForInventory = (
	value,
	setSuppliers,
	setIsLoading,
	isFistTime,
	setFixedSuppliers
) => {
	setIsLoading(true);
	let params = `?size=1000&materialType=${getMaterialType('FABRIC')}`;
	if (value) {
		params += `&name=${value}`;
	}
	ApiClient.GET('searchSupplier', params)
		.then((response) => {
			let tmpData = response.data.data?.map((item) => ({
				id: item.id,
				value: item.name,
				materialType: 'MAIN_FABRIC'
			}));
			const defaultObj = { id: null, value: 'Design fabric', materialType: 'DESIGN_FABRIC' };
			if (isFistTime) {
				tmpData.unshift(defaultObj);
				setFixedSuppliers(tmpData);
			}
			if (value && defaultObj.value.toUpperCase().includes(value.toUpperCase()))
				tmpData.unshift(defaultObj);
			setSuppliers(tmpData);

			setIsLoading(false);
		})
		.catch(() => {
			setIsLoading(false);
		});
};

export const fetchSupplierByMaterialType = async (value, materialType, setIsLoading, setSuppliers) => {
	let params = `?size=1000&materialType=${getMaterialType(materialType)}`;
	if (value) {
		params += `&name=${value}`;
	}
	await ApiClient.GET('searchSupplier', params).then((response) => {
		let tmpData = response.data.data?.map((item) => ({ id: item.id, value: item.name }));

		setSuppliers(tmpData);
	});
};
export const fetchNitexUsers = (value, setUserList, setIsLoading, isFistTime, setFixedUserList) => {
	setIsLoading(true);
	let params = `?isNitexUser=true&page=0&size=1000`;
	if (value) {
		params += `&search=${value}`;
	}
	ApiClient.GET('userSearch', params)
		.then((response) => {
			let tmpData = response.data.data?.map((item) => ({
				id: item.id,
				value: item.nickName ? item.nickName : item.name
			}));
			if (isFistTime) setFixedUserList(tmpData);
			setUserList(tmpData);
			setIsLoading(false);
		})
		.catch(() => {
			setIsLoading(false);
		});
};

export const isNumeric = (number) => {
	return !isNaN(parseFloat(number)) && isFinite(number);
};

export const fetchRACLocation = (
	value,
	setRACLocationList,
	setIsLoading,
	isFistTime,
	setFixedRACLocationList
) => {
	// setIsLoading(true);
	let params = `?page=0&size=1000`;
	if (value) {
		params += `&search=${value}`;
	}
	ApiClient.GET('racLocationSearch', params).then((response) => {
		let tmpData = response.data.data?.map((item) => ({ id: item.id, value: item.name }));
		if (isFistTime) setFixedRACLocationList(tmpData);
		setRACLocationList(tmpData);
		// setIsLoading(false);
	});
};

export const addUpdatedInventory = async (transactionType, requestList, setItemList, setIsLoading) => {
	setIsLoading(true);
	await ApiClient.POST('addUpdatedInventory', requestList, transactionType)
		.then((response) => {
			setItemList(requestList.pop());
			toastSuccess(response?.data?.message);
			setIsLoading(false);
		})
		.catch(() => {
			setIsLoading(false);
		});
};

export const onGetFabricSubCategory = async (setFabricSubCategory) => {
	await ApiClient.GET('getFabricSubCategory')
		.then(({ data }) => {
			if (data) {
				let subCategories = data?.map((item) => {
					return {
						id: item.id,
						value: `${item.fabricType}-${item.name}`,
						fabricType: item.fabricType,
						name: item.name
					};
				});
				setFabricSubCategory(subCategories);
			}
		})
		.catch(({ response }) => {
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Request was unsuccessful.');
			}
		});
};

export const fetchCompositionNameList = async (setCompositionNameList) => {
	await ApiClient.GET('getCompositionNameList')
		.then(({ data }) => {
			if (data) {
				let compositionNameList = data?.map((item) => {
					return {
						id: item,
						text: item,
						value: item,
						label: item
					};
				});
				setCompositionNameList(compositionNameList);
			}
		})
		.catch(({ response }) => {
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Request was unsuccessful.');
			}
		});
};

export const compositionDefaultFieldSet = (length, compositionPartList) => {
	let tempList = [];

	for (let i = 0; i < length; i++) {
		tempList.push({
			id: compositionPartList[i]?.id,
			percentage: compositionPartList[i]?.percentage,
			fiberObj: compositionPartList[i]
				? {
						id: compositionPartList[i]?.fiberName,
						text: compositionPartList[i]?.fiberName,
						value: compositionPartList[i]?.fiberName,
						label: compositionPartList[i]?.fiberName
					}
				: undefined,
			fiberName: compositionPartList[i]?.fiberName
		});
	}
	return tempList;
};
const validateInputNumber = (inputValue) => {
	const parsedValue = parseFloat(inputValue);
	if (isNaN(parsedValue)) {
		// Not a valid number
		return undefined;
	}
	if (parsedValue < 0.1 || parsedValue > 100) {
		// Outside of valid range
		return undefined;
	}
	// Valid input value
	return inputValue;
};
export const onChangeCompositionPercentage = (
	value,
	index,
	compositionFieldInfoList,
	setCompositionFieldInfoList
) => {
	let modifiedData = compositionFieldInfoList.map((obj, i) => {
		if (index === i) {
			obj.percentage = validateInputNumber(value);
		}
		return obj;
	});
	setCompositionFieldInfoList(modifiedData);
};

export const onChangeCompositionSelection = (
	item,
	index,
	compositionFieldInfoList,
	setCompositionFieldInfoList
) => {
	compositionFieldInfoList.map((obj, i) => {
		if (index === i) {
			obj.fiberObj = item;
			obj.fiberName = item?.value;
		}
	});

	const totalPercentage = compositionFieldInfoList.reduce(
		(total, item) => (total += Number(item?.percentage || 0)),
		0
	);

	if (compositionFieldInfoList.length - 1 === index && totalPercentage < 100) {
		setCompositionFieldInfoList([...compositionFieldInfoList, ...compositionDefaultFieldSet(2, [])]);
	} else {
		let copyList = [...compositionFieldInfoList];
		setCompositionFieldInfoList(copyList);
	}
};

export const compositionCalculation = (compositionFieldInfoList) => {
	let percentage = 0;
	let compositionPart = '';
	let percentageIsNotOk = true;
	let fiberNameIsNotOk = false;
	compositionFieldInfoList.map((item) => {
		if (item.percentage !== undefined) {
			percentage += parseFloat(item.percentage);
		}
		if (item.percentage !== undefined && item.fiberName === undefined) {
			fiberNameIsNotOk = true;
		}
		if (item.percentage !== undefined && item.fiberName !== undefined) {
			compositionPart += item.percentage + '% ' + item.fiberName + ' ';
		}
	});
	if (percentage === 100) {
		percentageIsNotOk = false;
		compositionPart = compositionPart.trim();
	}
	return {
		percentageIsNotOk,
		fiberNameIsNotOk,
		percentage,
		compositionPart
	};
};

export const getFabricCategory = (setIsAddNew, setFabricTypeList) => {
	setIsAddNew(true);
	fetchFabricCategory().then((data) => {
		setFabricTypeList(data);
	});
};

export const getSorting = (selectedType, isInventory, requestFrom = '') => {
	if (requestFrom === 'SUPPLIER') {
		return 'id,desc';
	} else {
		if (isInventory) return '';
		else return 'id,desc';
	}
};

export const extraSorting = (commonFilters, isInventory, productId, requestFrom = '') => {
	if (requestFrom === 'SUPPLIER') {
		return { ...commonFilters };
	} else {
		if (isInventory) return { ...commonFilters, sortInDesignTool: true, productIdToSort: productId };
		else
			return {
				...commonFilters,
				sortInDesignTool: false
			};
	}
};

/**
 * Trims and Accessories
 */

export const MATERIAL_TAG_TYPE = {
	CATEGORY: 'CATEGORY',
	MATERIAL_QUALITY: 'MATERIAL_QUALITY',
	TECHNIQUE: 'TECHNIQUE',
	SUSTAINABILITY: 'SUSTAINABILITY',
	BRAND: 'BRAND',
	MATERIAL_NUMBER: 'MATERIAL_NUMBER',
	SUPPLIER: 'SUPPLIER'
};

export const MATERIAL_TITLE_NAME = {
	FABRIC: 'Fabric',
	TRIMS: 'Trims',
	BRANDING: 'Accessories',
	TRIMS_ACCESSORIES: 'Trims'
};
export const areEqual = (array1 = [], array2 = []) => {
	if (!array1 && !array2) return true;
	const sortedArr1 = [...array1].sort();
	const sortedArr2 = [...array2].sort();
	return JSON.stringify(sortedArr1) === JSON.stringify(sortedArr2);
};
export const fetchCategoriesForTrimsOrAccessories = (urlName, setCategories) => {
	ApiClient.GET(urlName)
		.then(({ data }) => {
			let tmpCategories = data?.map((item) => {
				return { ...item, value: item.name };
			});
			setCategories(tmpCategories);
		})
		.catch((err) => {
			toastError(err.response.data.message);
		});
};
export const fetchMaterialNumberForTrimsOrAccessories = (urlName, subCategoryId, setMaterialNumberList) => {
	ApiClient.GET(urlName, subCategoryId)
		.then((response) => {
			let tmpMaterialNumberList = response.data.map((item) => {
				return { id: item, value: item };
			});

			setMaterialNumberList(tmpMaterialNumberList);
		})
		.catch((err) => {
			toastError(err.response.data.message);
		});
};
export const fetchTagsForTrimsOrAccessories = (search = '', type, setList) => {
	let params = `?page=0&size=1000&type=${type}&search=${search}`;
	ApiClient.GET('getAllTags', params)
		.then(({ data }) => {
			let tmpCategories = [];
			for (let item of data) {
				tmpCategories.push({ ...item, value: item.text, name: item.text });
			}
			if (type === MATERIAL_TAG_TYPE.TECHNIQUE) setList(tmpCategories);
			else if (type === MATERIAL_TAG_TYPE.MATERIAL_QUALITY) setList(tmpCategories);
			if (type === MATERIAL_TAG_TYPE.SUSTAINABILITY) setList(tmpCategories);
		})
		.catch((err) => {
			toastError(err.response.data.message);
		});
};

export const generateMaterialNameForTrimsOrAccessories = (selectedCategories, trimsAndAccessoriesInfo) => {
	let name = '';
	if (trimsAndAccessoriesInfo?.categoryId !== undefined) {
		name += selectedCategories.name;
	} else {
		return name;
	}
	if (trimsAndAccessoriesInfo?.sustainabilityTagRequest?.text !== undefined) {
		name += ', ' + trimsAndAccessoriesInfo?.sustainabilityTagRequest?.text;
	}
	if (trimsAndAccessoriesInfo?.materialQualityTagRequest?.text !== undefined) {
		name += ', ' + trimsAndAccessoriesInfo?.materialQualityTagRequest?.text;
	}
	if (
		trimsAndAccessoriesInfo?.widthFromEdges !== undefined &&
		!isNaN(trimsAndAccessoriesInfo?.widthFromEdges) &&
		selectedCategories?.widthFromEdges !== undefined
	) {
		name +=
			', ' +
			trimsAndAccessoriesInfo?.widthFromEdges +
			selectedCategories?.widthFromEdges +
			' width (from edges)';
	}
	if (
		trimsAndAccessoriesInfo?.length !== undefined &&
		!isNaN(trimsAndAccessoriesInfo?.length) &&
		selectedCategories?.length !== undefined
	) {
		name += ', ' + trimsAndAccessoriesInfo?.length + ' ' + selectedCategories?.length + ' length';
	}
	if (
		trimsAndAccessoriesInfo?.height !== undefined &&
		!isNaN(trimsAndAccessoriesInfo?.height) &&
		selectedCategories?.height !== undefined
	) {
		name += ', ' + trimsAndAccessoriesInfo?.height + ' ' + selectedCategories?.height + ' height';
	}
	if (
		trimsAndAccessoriesInfo?.widthInside !== undefined &&
		!isNaN(trimsAndAccessoriesInfo?.widthInside) &&
		selectedCategories?.widthInside !== undefined
	) {
		name +=
			', ' +
			trimsAndAccessoriesInfo?.widthInside +
			' ' +
			selectedCategories?.widthInside +
			' width(inside)';
	}
	if (
		trimsAndAccessoriesInfo?.diameter !== undefined &&
		!isNaN(trimsAndAccessoriesInfo?.diameter) &&
		selectedCategories?.diameter !== undefined
	) {
		name += ', ' + trimsAndAccessoriesInfo?.diameter + ' ' + selectedCategories?.diameter + ' diameter';
	}
	if (
		trimsAndAccessoriesInfo?.zipperNumber !== undefined &&
		!isNaN(trimsAndAccessoriesInfo?.zipperNumber) &&
		selectedCategories?.zipperNumber !== undefined
	) {
		name +=
			', ' +
			trimsAndAccessoriesInfo?.zipperNumber +
			' ' +
			selectedCategories?.zipperNumber +
			' zipper number';
	}
	if (
		trimsAndAccessoriesInfo?.numberOfHole !== undefined &&
		!isNaN(trimsAndAccessoriesInfo?.numberOfHole) &&
		selectedCategories?.numberOfHole !== undefined
	) {
		name +=
			', ' +
			trimsAndAccessoriesInfo?.numberOfHole +
			' ' +
			selectedCategories?.numberOfHole +
			' Number of hole';
	}
	if (trimsAndAccessoriesInfo?.details !== undefined) {
		name += ', ' + trimsAndAccessoriesInfo?.details;
	}
	trimsAndAccessoriesInfo.name = name;
};
export const enumObj = {
	DESIGNS: 'DESIGNS',
	MATERIAL: 'MATERIAL',
	MATERIAL_EDIT: 'MATERIAL_EDIT'
};

export const categoryTypeSustainabilityForTrimsAndBranding = (itemInfo, isRegularShow = true) => {
	return (
		(itemInfo?.sustainability && (isRegularShow || itemInfo?.sustainability?.text !== 'Regular')
			? itemInfo?.sustainability?.text
			: '') +
		(itemInfo?.sustainability &&
		(isRegularShow || itemInfo?.sustainability?.text !== 'Regular') &&
		itemInfo?.materialQuality
			? ', '
			: '') +
		(itemInfo?.materialQuality ? itemInfo?.materialQuality?.text : '')
	);
};
export const someDetailsForTrimsAndBrandingRender = (itemInfo) => {
	return (
		<>
			{itemInfo?.widthFromEdges && itemInfo?.subCategoryType?.widthFromEdges && (
				<p className="regular-14 gray_dark_01">
					Width(Edges): {itemInfo?.widthFromEdges} {itemInfo?.subCategoryType?.widthFromEdges}
				</p>
			)}
			{itemInfo?.widthInside && itemInfo?.subCategoryType?.widthInside && (
				<p className="regular-14 gray_dark_01">
					Width(Inside): {itemInfo?.widthInside} {itemInfo?.subCategoryType?.widthInside}
				</p>
			)}
			{itemInfo?.diameter && itemInfo?.subCategoryType?.diameter && (
				<p className="regular-14 gray_dark_01">
					Diameter: {itemInfo?.diameter} {itemInfo?.subCategoryType?.diameter}
				</p>
			)}
			{itemInfo?.length && itemInfo?.subCategoryType?.length && (
				<p className="regular-14 gray_dark_01">
					Length: {itemInfo?.length} {itemInfo?.subCategoryType?.length}
				</p>
			)}
			{itemInfo?.height && itemInfo?.subCategoryType?.height && (
				<p className="regular-14 gray_dark_01">
					Height: {itemInfo?.height} {itemInfo?.subCategoryType?.height}
				</p>
			)}
			{itemInfo?.zipperNumber && itemInfo?.subCategoryType?.zipperNumber && (
				<p className="regular-14 gray_dark_01">
					Zipper Number: {itemInfo?.zipperNumber} {itemInfo?.subCategoryType?.zipperNumber}
				</p>
			)}
			{itemInfo?.numberOfHole && itemInfo?.subCategoryType?.numberOfHole && (
				<p className="regular-14 gray_dark_01">
					Number Of Hole: {itemInfo?.numberOfHole} {itemInfo?.subCategoryType?.numberOfHole}
				</p>
			)}
			{itemInfo?.technique?.text && (
				<p className="regular-14 gray_dark_01 mt-2">{itemInfo?.technique?.text}</p>
			)}
			{itemInfo?.details && <p className="regular-14 gray_dark_01 mt-2">{itemInfo?.details}</p>}
			{itemInfo?.specificBrandResponse && (
				<p className="regular-14 gray_dark_01">{itemInfo?.specificBrandResponse?.name}</p>
			)}
		</>
	);
};

export const getTabName = (selectedType) => {
	let tabName = selectedType;
	if (selectedType === MATERIALS_TYPE.TRIMS_ACCESSORIES) {
		tabName = 'TRIMS';
	} else if (selectedType === MATERIALS_TYPE.BRANDING) {
		tabName = 'ACCESSORIES';
	}
	return tabName;
};

export const fetchApplicationGarmentsTypeList = async (setAppGarments) => {
	// setIsLoading(true);
	await ApiClient.GET('applicationGarmentsType', { page: 0, size: 1000 })
		.then(({ data }) => {
			// setIsLoading(false);
			let tmpData = data?.map((item) => ({
				id: item.id,
				value: item.name,
				label: item.name,
				...item
			}));
			setAppGarments(tmpData);
		})
		.catch(({ response }) => {
			if (response && response.data && response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Request was unsuccessful.');
			}
		});
};

export const fetchAllSuppliersMaterialsForAllSticker = (
	type,
	sort,
	filterParams = {},
	setSelectedMaterialListForSticker,
	setIsLoading
) => {
	const params = {
		page: 0,
		size: 100,
		supplierType: type,
		...removeEmptyFilterParams(filterParams),
		sort
	};
	setIsLoading(true);
	let url = 'getAllMaterialStickersMax100';
	ApiClient.POST(url, params)
		.then(({ data }) => {
			setIsLoading(false);
			setSelectedMaterialListForSticker(data?.data);
		})
		.catch((error) => {
			setIsLoading(false);
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		});
};

export const fetchFavouriteMaterialsForAllSticker = (
	search = '',
	setSelectedMaterialListForSticker,
	setIsLoading
) => {
	setIsLoading(true);
	let params = `?page=${0}&size=${100}&search=${search}`;
	ApiClient.GET('getFavouriteMaterialsMax100', params)
		.then(({ data }) => {
			setIsLoading(false);
			setSelectedMaterialListForSticker(data?.data);
		})
		.catch((error) => {
			setIsLoading(false);
			if (error.message) {
				toastError(error.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		});
};

export const fetchSingleMaterial = async (
	type,
	id,
	setIsLoading,
	materialsDataList,
	setMaterialsDataList
) => {
	setIsLoading(true);
	const params = { supplierType: type, materialIdList: [id] };
	let url = 'getSuppliersMaterials';
	if (type === 'GARMENTS') {
		url = 'fetchGarments';
	}

	await ApiClient.POST(url, params)
		.then(({ data }) => {
			if (data?.data?.length === 1) {
				materialsDataList.data = materialsDataList?.data?.map((item) => {
					if (data?.data[0].materialId === item?.materialId) {
						item = data?.data[0];
					}
					return item;
				});
				setMaterialsDataList({ ...materialsDataList });
			}
			setIsLoading(false);
		})
		.catch(() => {
			setIsLoading(false);
		});
};

export const fetchAllBriefMaterialWithoutRedux = async (type, search, setAllMaterial) => {
	ApiClient.GET('getAllMaterialsBrief', { page: 0, size: 20, supplierType: type, ...search }).then(
		({ data }) => {
			let tempList = data?.data?.map((item) => {
				return {
					id: item.id,
					value: item.name
				};
			});
			setAllMaterial(tempList);
		}
	);
};

export const isValidFormForBinding = (value, key, massage, setErrors) => {
	if (value === undefined || (typeof value === 'string' && value.toString().trim() === '')) {
		setErrors((prevState) => ({ ...prevState, [key]: massage }));
	} else {
		setErrors((prevState) => ({ ...prevState, [key]: undefined }));
	}
	if (value === undefined || (typeof value === 'number' && isNaN(value))) {
		setErrors((prevState) => ({ ...prevState, [key]: massage }));
	} else {
		setErrors((prevState) => ({ ...prevState, [key]: undefined }));
	}
};

export const onGetFabricTypeList = async (commonfilters) => {
	try {
		let params = '';
		if (commonfilters?.fabricTypes) {
			const ids = commonfilters['fabricTypes']?.map((item) => item.id);
			params = `?fabricType=${ids}`;
			const { data } = await ApiClient.GET('getFabricSubCategory', params);
			return data;
		}
	} catch (error) {
		printApiError(error);
	}
};

export const MATERIAL_TOGGLE_OPTIONS = {
	IS_ADD_MATERIAL_FAVOURITE_TOGGLE_ON: 'IS_ADD_MATERIAL_FAVOURITE_TOGGLE_ON',
	IS_EDIT_MATERIAL_TOGGLE_ON: 'IS_EDIT_MATERIAL_TOGGLE_ON',
	IS_VIEW_MATERIAL_DETAILS_TOGGLE_ON: 'IS_VIEW_MATERIAL_DETAILS_TOGGLE_ON',
	IS_ISSUE_FABRIC_TOGGLE_ON: 'IS_ISSUE_FABRIC_TOGGLE_ON',
	IS_SEARCH_WITH_REF_NO: 'IS_SEARCH_WITH_REF_NO',
	IS_SEARCH_WITH_SUPPLIER_REF_NO: 'IS_SEARCH_WITH_SUPPLIER_REF_NO',
	IS_SEARCH_WITH_QR: 'IS_SEARCH_WITH_QR',
	IS_SEARCH_WITH_FABRIC_TITLE_OR_COLOR: 'IS_SEARCH_WITH_FABRIC_TITLE_OR_COLOR',
	IS_SEARCH_WITH_NAME_AND_REF_NO: 'IS_SEARCH_WITH_NAME_AND_REF_NO',
	IS_SEARCH_WITH_QR_CODE: 'IS_SEARCH_WITH_QR_CODE'
};

export const materialColortabs = {
	SOLID: 'Solid',
	AOP: 'AOP',
	YARN_DYED: 'Y/D'
};

export const matchingMaterialTabs = {
	Fabric: ['MAIN_FABRIC', 'EXTRA_FABRIC', 'LIBRARY_FABRIC'],
	Trims: ['TRIMS']
};

export const formatPairMaterialApiResponse = (response) => {
	return response.map((item) => ({
		...item.materialTableResponse,
		pairType: item.pairType
	}));
};

export const goToMaterialView = (id, type) => {
	let url = `/materials/view/${id}?type=${type}`;
	window.open(url, '_blank');
};
